<pagination-template
  #p="paginationApi"
  [id]="id"
  (pageChange)="pageChange.emit($event)"
  class="flex items-center text-slate-400"
  >
  <div class="w-48 pr-5 text-sm">
    {{getCurrentPageInfo(p)}}
  </div>

  <div class="px-5 flex-1">
    <nav class="flex justify-center items-center space-x-5">
      <a
        class="inline-flex rounded-md px-2.5 py-1.5"
        (click)="!p.isFirstPage() && p.previous()"
        [ngClass]="{
          'bg-sky-100 cursor-pointer': !p.isFirstPage(),
          'bg-slate-100': p.isFirstPage()
        }"
        >
        <svg
          class=" w-4 h-4"
          [ngClass]="{
            'text-sky-500': !p.isFirstPage(),
            'text-slate-400/60': p.isFirstPage()
          }"
          >
          <use xlink:href="assets/icons/symbols.svg#arrow-left"></use>
        </svg>
      </a>

      @for (page of p.pages; track page.value) {
        <div [class.current]="p.getCurrent() === page.value">
          @if (p.getCurrent() !== page.value) {
            <a (click)="p.setCurrent(page.value)" class="cursor-pointer">
              <span>{{ page.label }}</span>
            </a>
          }
          @if (p.getCurrent() === page.value) {
            <span class="font-bold text-sky-500">
              <span>{{ page.label }}</span>
            </span>
          }
        </div>
      }

      <div [class.disabled]="p.isLastPage()">
        <a
          class="inline-flex rounded-md px-2.5 py-1.5"
          (click)="p.pages.length && !p.isLastPage() && p.next()"
          [ngClass]="{
            'bg-sky-100': !p.isLastPage(),
            'bg-slate-100': p.isLastPage()
          }"
          >
          <svg
            class="w-4 h-4"
            [ngClass]="{
              'text-sky-500 cursor-pointer': !p.isLastPage(),
              'text-slate-400/60': p.isLastPage()
            }"
            >
            <use xlink:href="assets/icons/symbols.svg#arrow-right"></use>
          </svg>
        </a>
      </div>
    </nav>
  </div>

  <div class="w-48 pl-5 text-sm">
    <div class="flex justify-end items-center">
      Items per page:
      <select class="ml-2.5 p-1 w-12" (change)="onLimitChange(limitSelect)" #limitSelect>
        @for (option of [10, 15, 30, 50]; track option) {
          <option
            [value]="option"
            [selected]="limit() === option"
            >
            {{option}}
          </option>
        }
      </select>
    </div>
  </div>
</pagination-template>
